/* eslint-disable no-console */
// src/fcmService.js
import { messagingPromise, getToken, onMessage } from './firebase';
import { callApi } from './utils/apiCall';

const VAPID_KEY = import.meta.env.VITE_REACT_APP_VAPID_KEY;

export const requestAndRegisterFCMToken = async (currentPractice) => {
    try {
        const messaging = await messagingPromise;
        if (!messaging) return;

        const permission = await Notification.requestPermission();

        if (permission !== 'granted') {
            console.warn("Notification permission not granted.");
            return;
        }

        const token = await getToken(messaging, { vapidKey: VAPID_KEY });

        const currentPracticeFromLocalStorage = localStorage.getItem("currentPractice");

        // Generate or fetch device_id
        let deviceId = localStorage.getItem("device_id");
        if (!deviceId || `${currentPracticeFromLocalStorage}` !== `${currentPractice}`) {
            deviceId = crypto.randomUUID();
            localStorage.setItem("device_id", deviceId);
            localStorage.setItem("currentPractice", currentPractice);
        }

        // Register device with your backend
        await callApi('/api/v1/fcm/devices/', 'POST',
            {
                name: "Web Device",
                registration_id: token,
                device_id: deviceId,
                active: true,
                type: "web",
                practice: currentPractice
            },
        );
    } catch (err) {
        console.error("FCM registration error:", err);
    }
};

// Handle foreground notifications
export const listenForForegroundMessages = async (showCustomNotification) => {
    try {
        const messaging = await messagingPromise;
        if (!messaging) return;

        onMessage(messaging, (payload) => {
            showCustomNotification(payload);
        });
    } catch (err) {
        console.error("FCM foreground listener error:", err);
    }
};